import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { getUser } from './useUser'
import { getStore } from 'common/store'

export const addressService = service
  .enhanceEndpoints({ addTagTypes: ['Address'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      changeForwardAddress: builder.mutation<
        Res['changeForwardAddress'],
        Req['changeForwardAddress']
      >({
        invalidatesTags: [],
        query: (query: Req['changeForwardAddress']) => ({
          body: query,
          method: 'PUT',
          url: `/customers/subscriptions/${query.subscription_id}`,
        }),
        transformResponse: async (response: Res['changeForwardAddress']) => {
          await getUser(getStore(), {}, { forceRefetch: true })
          return response
        },
      }),

      // END OF ENDPOINTS
    }),
  })

export async function changeForwardAddress(
  store: any,
  data: Req['changeForwardAddress'],
  options?: Parameters<
    typeof addressService.endpoints.changeForwardAddress.initiate
  >[1],
) {
  return store.dispatch(
    addressService.endpoints.changeForwardAddress.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useChangeForwardAddressMutation,
  // END OF EXPORTS
} = addressService

/* Usage examples:
const { data, isLoading } = useGetAddressQuery({ id: 2 }, {}) //get hook
const [createAddress, { isLoading, data, isSuccess }] = useCreateAddressMutation() //create hook
*/
